import Marquee from "react-fast-marquee";
import { useI18n } from "@/i18n/I18nContext";

export default function EditorialMarquee() {
  const { t, dir } = useI18n();
  const text = t("marquee");
  return (
    <div className="border-y border-border bg-background py-6" data-testid="editorial-marquee">
      <Marquee speed={38} gradient={false} direction={dir === "rtl" ? "right" : "left"} autoFill>
        {[0, 1].map((i) => (
          <span
            key={i}
            className="font-display text-4xl font-bold uppercase tracking-tight md:text-6xl text-stroke mx-8"
          >
            {text} <span className="mx-8 text-primary" style={{ WebkitTextStroke: "0" }}>—</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
